module.exports = __webpack_public_path__ + "static/media/bindOutlook2.ddc924e2.png";